import React from "react";
import {Card} from 'react-bootstrap';


function STCCardText(props){

    return(
        <Card.Text

            style={props.style}
            className={props.className}

            as={props.as}
            bsPrefix={props.bsPrefix}
        >
            {props.children}
        </Card.Text>
    )
}
export default STCCardText;